
(function () {
  'use strict';

  var FS = window.FS, qs = FS.qs, qsa = FS.qsa, once = FS.once, Overlay = FS.Overlay;

  function buildSlots(wrap, timeInput, dateStr) {
    wrap.innerHTML = '';
    var startHour = 10, endHour = 19;
    var now = new Date();
    var isToday = dateStr === now.toISOString().slice(0, 10);
    var picked = null;

    function label(h, m) {
      var h12 = h % 12 === 0 ? 12 : h % 12;
      var period = h < 12 ? 'AM' : 'PM';
      return h12 + ':' + m + ' ' + period;
    }

    for (var hour = startHour; hour <= endHour; hour++) {
      ['00', '30'].forEach(function (minute) {
        if (hour === endHour && minute === '30') return;
        var slotTime = new Date(now);
        slotTime.setHours(hour, parseInt(minute, 10), 0, 0);
        if (isToday && slotTime <= now) return;

        var text = label(hour, minute);
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'live-shop-slot';
        btn.textContent = text;
        btn.addEventListener('click', function () {
          if (picked) picked.classList.remove('is-selected');
          btn.classList.add('is-selected');
          picked = btn;
          timeInput.value = text;
        });
        wrap.appendChild(btn);
      });
    }
    if (!wrap.children.length) {
      var none = document.createElement('p');
      none.className = 'live-shop-slots__empty';
      none.textContent = FS.T.strings.liveShopNoSlots || 'No slots left today — pick another date.';
      wrap.appendChild(none);
    }
    timeInput.value = '';
  }

  function initLiveShop(ctx) {
    var modal = qs('[data-live-shop-modal]');
    if (modal && once(modal, 'LiveShop')) {
      var closeBtn = qs('[data-live-shop-close]', modal);
      if (closeBtn) closeBtn.addEventListener('click', function () { Overlay.hide(modal); });
      modal.addEventListener('click', function (e) { if (e.target === modal) Overlay.hide(modal); });

      var dateInput = qs('[data-live-shop-date]', modal);
      var slotsWrap = qs('[data-live-shop-slots]', modal);
      var timeInput = qs('[data-live-shop-time]', modal);
      if (dateInput && slotsWrap && timeInput) {
        buildSlots(slotsWrap, timeInput, dateInput.value);
        dateInput.addEventListener('change', function () { buildSlots(slotsWrap, timeInput, dateInput.value); });
      }
    }

    qsa('[data-live-shop-open]', ctx).forEach(function (btn) {
      if (!once(btn, 'LiveShopOpen')) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        Overlay.show(modal);
      });
    });
  }

  window.FS.initLiveShop = initLiveShop;
})();
